import { render, staticRenderFns } from "./chkResultRegister.vue?vue&type=template&id=9d962804&"
import script from "./chkResultRegister.vue?vue&type=script&lang=js&"
export * from "./chkResultRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports